import { faker } from '@faker-js/faker';

import { mockPaginate } from './paginate';
import {
  AuditTrialType,
  ScoringStatuses,
} from '@dynamika-shared/types/auditTrial';
import { AuditTrailStatuses } from '@dynamika-shared/types/status';

export function createRandomClinicalTrial(
  id?: string,
  payloadWithScoring?: boolean
): AuditTrialType {
  return {
    id: id ?? faker.string.uuid(),
    dateAndTime: faker.date.past().toISOString(),
    actionByName: faker.string.alphanumeric(6),
    actionByEmail: faker.string.alphanumeric(6),
    attributes: {
      readingCode: faker.string.alphanumeric({ length: { min: 3, max: 10 } }),
      clinicalTrialId: faker.string.alphanumeric({
        length: { min: 3, max: 12 },
      }),
      clinicalTrialName: faker.string.alphanumeric({
        length: { min: 3, max: 10 },
      }),
      subjectCode: faker.string.alphanumeric({ length: { min: 3, max: 10 } }),
      subjectId: faker.string.alphanumeric({ length: { min: 3, max: 10 } }),
      visitDefinitionName: faker.string.alphanumeric({
        length: { min: 3, max: 10 },
      }),
    },
    businessProcess: faker.string.alphanumeric({ length: { min: 4, max: 12 } }),
    event: faker.string.alphanumeric({ length: { min: 5, max: 8 } }),
    actionType: faker.string.alphanumeric({ length: { min: 4, max: 6 } }),
    payloads: payloadWithScoring
      ? [
          {
            entityData: {
              signature: faker.string.alphanumeric({
                length: { min: 64, max: 64 },
              }),
              signDate: faker.date.anytime(),
              status: faker.helpers.arrayElement(
                AuditTrailStatuses
              ) as ScoringStatuses,
              scoring: {
                l1: { grade: 'Grade0', comment: '' },
                l2: { grade: 'Grade0', comment: '' },
                l3: { grade: 'Grade0', comment: '' },
                l4: { grade: 'Grade0', comment: '' },
                t4: { grade: 'Grade0', comment: '' },
                t5: { grade: 'Grade0', comment: '' },
                t6: { grade: 'Grade0', comment: '' },
                t7: { grade: 'Grade0', comment: '' },
                t8: { grade: 'Grade0', comment: '' },
                t9: { grade: 'Grade0', comment: '' },
                t10: { grade: 'Grade0', comment: '' },
                t11: { grade: 'Grade0', comment: '' },
                t12: { grade: 'Grade0', comment: '' },
                comment: 'Reader 1 comment',
                imageQuality: 'Suitable',
              },
            },
            entityName: faker.string.alphanumeric({
              length: { min: 3, max: 12 },
            }),
          },
        ]
      : [
          {
            fieldName: faker.string.alphanumeric({
              length: { min: 3, max: 6 },
            }),
            newValue: faker.string.alphanumeric({ length: { min: 3, max: 6 } }),
            oldValue: faker.string.alphanumeric({ length: { min: 3, max: 6 } }),
          },
        ],
    reasonForModification: faker.string.alphanumeric({
      length: { min: 4, max: 8 },
    }),
  };
}

export function createRandomAuditTrialsList(
  count: number,
  payloadWithScoring: boolean
): AuditTrialType[] {
  return faker.helpers.multiple(
    () => createRandomClinicalTrial(undefined, payloadWithScoring),
    {
      count,
    }
  );
}

export const createPaginatedRandomAuditTrialsList = (
  count: number,
  payloadWithScoring: boolean,
  args = { page: 1, size: 10 }
) => {
  const clinicalTrialsList = createRandomAuditTrialsList(
    count,
    payloadWithScoring
  );
  return mockPaginate(clinicalTrialsList, args);
};
